import React, { useEffect, useState } from 'react';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import pencilIcon from './../../../../assets/icons/editPencil.png';
import bin from './../../../../assets/icons/recycle-binColor.png';
import { Button, Grid } from '@mui/material';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal';
import { toast } from 'react-toastify';
import AddFoodCategoryDialog from '../FoodCategory/AddfoodCategory.tsx';
import EditFoodCategoryDialog from './EditFoodCategory.tsx';

function FoodCategorySetupPage(props) {
    const columns = [
        { 
            field: 'name', 
            headerName: 'Food Category Name', 
            align: 'center',
            renderCell: (params) => (
                <div className='d-flex align-items-center justify-content-center' style={{ gap: "5px", cursor: "pointer" }}>
                    <span style={{ color: "blue", cursor: "pointer" }}>{params.value}</span>
                    {params.row.creatorRestaurantId === restaurant?.id && (            
                        <img 
                            src={pencilIcon} 
                            alt="edit" 
                            style={{ width: ".8rem", cursor: 'pointer' }} 
                            onClick={() => handleEditClick(params.row)} 
                        />
                    )}
                </div>
            ),
            headerAlign: 'center', 
            flex: 1 
        },
        { 
            field: 'restaurantname', 
            headerName: 'Restaurant Name', 
            align: 'center', 
            headerAlign: 'center', 
            flex: 1 
        },
    ];

    const [dataRows, setDataRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [openAddSection, setOpenAddSection] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const [selectedDataRows, setSelectedDatarows] = useState([]); 
    const [openConfirmaitonModal, setOpenConfirmaitonModal] = useState(false); 
    const [isSubmitting, setIsSubmitting] = useState(false);
    const restaurant = JSON.parse(localStorage.getItem('restaurant'));
    const apiAddress = process.env.REACT_APP_SECRET;

    useEffect(() => {
        loadData(); 
    }, []);

   
    const loadData = () => {
        axios.get(apiAddress + '/api/FoodCategory/getFoodCategory')
            .then((response) => {
                const categories = response.data.map((dt) => ({
                    id: dt.id,
                    name: dt.categoryName,
                    restaurantname: dt.restaurantName,
                    creatorRestaurantId: dt.creatorRestaurantId
                }));
                setDataRows(categories); 
            })
            .catch((error) => {
                console.error('Error fetching food categories:', error);
            });
    };

    const handleEditClick = (category) => {
        const requestingRestaurantId = restaurant?.id;

        axios.get(apiAddress + '/api/FoodCategory/CanEditDeleteorNot', {
            params: {
                categoryId: category.id,
                requestingRestaurantId: requestingRestaurantId
            }
        })
        .then((response) => {
            if (!response.data) {
                toast.error("You are not authorized to edit this category.May be the category is using by other restaurant");
            } else {
                setSelectedCategoryId(category.id);
                setOpen(true);
            }
        })
        .catch((error) => {
            console.error(error);
            toast.error("Failed to check edit permissions.");
        });
    };


    const deleteBin = async () => {
        const url = apiAddress + "/api/FoodCategory/DeleteFoodCategorybyId";
        const requestingRestaurantId = restaurant?.id;
    
        try {

            const permissionChecks = selectedDataRows.map(async (categoryId) => {
                const response = await axios.get(apiAddress + '/api/FoodCategory/CanEditDeleteorNot', {
                    params: {
                        categoryId: categoryId,
                        requestingRestaurantId: requestingRestaurantId
                    }
                });
                return response.data; 
            });
    
            const permissionResults = await Promise.all(permissionChecks);
    
           
            if (permissionResults.includes(false)) {
                toast.error("You are not authorized to delete the selected categories.May be the category is using by other restaurant");
                setOpenConfirmaitonModal(false)
                return;
            }
            await axios.put(url, selectedDataRows);
    
            toast.success("Successfully deleted", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            loadData(); 
            setOpenConfirmaitonModal(false);
        } catch (error) {
            toast.error("Error deleting categories");
            setOpenConfirmaitonModal(false);
        }
    };
    const handleAddItem = (AddSectionData) => {
        setOpenAddSection(AddSectionData);
        loadData(); 
    };

    const handleUpdateItem = (AddItemData) => {
        setOpen(AddItemData);
        loadData(); 
    };

    const getSelectedData = (selectedRows) => {
        setSelectedDatarows(selectedRows); 
    };

    const errorToast = (msg) => {
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    return (
        <div>
            <Grid container alignItems="center" justifyContent="space-between" mt={2} mb={2}>
                <SweetAlertModal 
                    headerText={"Are you sure?"} 
                    bodyText={"You want to delete these categories?"} 
                    open={openConfirmaitonModal} 
                    onyes={deleteBin} 
                    close={() => { setOpenConfirmaitonModal(false); }}
                />
                <Grid item>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <Button
                                color="primary"
                                size="medium"
                                variant="contained"
                                style={{ borderRadius: '50%', minWidth: 'auto' }}
                                onClick={() => setOpenAddSection(true)}
                            >
                                +
                            </Button>
                        </Grid>   
                        <Grid item>
                            <div className='roundedCorner'>
                                <img 
                                    src={bin} 
                                    alt="delete" 
                                    style={{ width: '1rem', cursor: 'pointer' }} 
                                    onClick={() => {
                                        selectedDataRows.length === 0 
                                            ? errorToast("Please select a row")
                                            : setOpenConfirmaitonModal(true);
                                    }} 
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <CustomDataGrid 
                columns={columns} 
                dataRows={dataRows} 
                getselectedData={getSelectedData} 
            />
            <AddFoodCategoryDialog 
                open={openAddSection}
                dialogType={dialogType} 
                onHandleAddItem={handleAddItem}
                setIsSubmitting={setIsSubmitting}
                isSubmitting={isSubmitting}
            />
            {open && (
                <EditFoodCategoryDialog 
                    open={open}
                    onHandleAddItem={handleUpdateItem}
                    title={props.title} 
                    isEdit={true} 
                    selectedId={selectedCategoryId} 
                />
            )}
        </div>
    );
}

export default FoodCategorySetupPage;